import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";
import { FormlyView } from "../FormlyView";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { LookupGetService } from "../../../service/lookup-service/lookup-get.service";

export class DrugIndication extends FormlyView {

    constructor(
        injector: Injector,
        fieldDefinition: FieldDefinition,
        operationtype: any
    ) {

        let productIndicationFields: FormlyFieldConfig[] = [...fieldDefinition.productIndicationItemFields];
        if (operationtype && ([4, 6].includes(operationtype))) {

            productIndicationFields[0].fieldGroup![0].props!["disabled"] = true;
            productIndicationFields[0].fieldGroup![0].props!["options"] = injector
                .get(LookupGetService)
                .loadCachedOptions('supportedbacklogmeddraversions');


        }

        super(new FormGroup({}),
            productIndicationFields, {});
    }

}